module.exports = __webpack_public_path__ + "static/img/9.0e71874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/9.png
// module id = 1+kr
// module chunks = 0